import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Back from "../components/button/back";

const KegiatanForAll = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchKegiatan = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}api/kegiatan/${id}`
        );
        setData(res.data);
      } catch (err) {
        console.error("Gagal memuat data kegiatan:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchKegiatan();
  }, [id]);

  const convertToEmbedURL = (url) => {
    if (!url) return null;

    if (url.includes("youtube.com/watch?v=")) {
      const videoId = new URL(url).searchParams.get("v");
      return `https://www.youtube.com/embed/${videoId}`;
    }

    if (url.includes("youtu.be/")) {
      const videoId = url.split("youtu.be/")[1];
      return `https://www.youtube.com/embed/${videoId}`;
    }

    if (url.includes("drive.google.com/file/d/")) {
      const fileId = url.split("/d/")[1]?.split("/")[0];
      return `https://drive.google.com/file/d/${fileId}/preview`;
    }

    return null;
  };

  const isImageLink = (url) => /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(url);

  if (loading)
    return (
      <p className="text-center mt-10 text-gray-500 dark:text-gray-400">
        Memuat...
      </p>
    );

  if (!data)
    return (
      <p className="text-center mt-10 text-red-500">Data tidak ditemukan.</p>
    );

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors p-4 sm:p-6 lg:p-8">
      {/* Back */}
      <div className="pt-5 pb-5">
        <Link to="/kegiatan">
          <Back />
        </Link>
      </div>

      {/* Judul */}
      <h2 className="text-2xl sm:text-3xl font-bold mb-6 text-center text-gray-800 dark:text-white">
        {data.judul}
      </h2>

      {/* Media dari server */}
      {data.media?.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mb-6">
          {data.media.map((m) => (
            <div
              key={m.fileId}
              className="bg-white dark:bg-gray-800 shadow-lg rounded-2xl overflow-hidden hover:shadow-2xl transition-shadow duration-300"
            >
              {m.mimetype.startsWith("image") ? (
                <img
                  src={`${process.env.REACT_APP_API_URL}api/kegiatan/media/${m.filename}`}
                  alt="media"
                  className="w-full h-56 object-cover"
                />
              ) : (
                <video
                  controls
                  className="w-full h-56 bg-black object-cover"
                  src={`${process.env.REACT_APP_API_URL}api/kegiatan/media/${m.filename}`}
                />
              )}
            </div>
          ))}
        </div>
      )}

      {/* Link tambahan */}
      {data.link && (
        <div className="mb-6">
          <h3 className="font-semibold mb-2 text-gray-700 dark:text-gray-300">
            Link Tambahan:
          </h3>

          {isImageLink(data.link) ? (
            <img
              src={data.link}
              alt="Link Gambar"
              className="w-full max-h-96 object-contain border rounded-lg shadow"
            />
          ) : convertToEmbedURL(data.link) ? (
            <div className="w-full aspect-video rounded-lg overflow-hidden shadow">
              <iframe
                src={convertToEmbedURL(data.link)}
                title="Video/Embed Link"
                allowFullScreen
                className="w-full h-full"
              ></iframe>
            </div>
          ) : (
            <a
              href={data.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 dark:text-blue-400 underline"
            >
              {data.link}
            </a>
          )}
        </div>
      )}

      {/* Deskripsi */}
      <div className="mb-10">
        <h3 className="font-semibold mb-2 text-gray-700 dark:text-gray-300">
          Deskripsi:
        </h3>
        <p className="text-gray-700 dark:text-gray-300 whitespace-pre-line">
          {data.deskripsi}
        </p>
      </div>

      {/* Back Button bawah */}
      <div className="pt-5 pb-5">
        <Link to="/kegiatan">
          <Back />
        </Link>
      </div>
    </div>
  );
};

export default KegiatanForAll;
